import React from 'react';
import PropTypes from 'prop-types';
import './logo.scss';

const LogoImage = (props) => (
  <div className={`logo-image ${props.darkBackground ? 'logo-image--dark-background' : ''}`}></div>
);

export default LogoImage;

LogoImage.propTypes = {
  darkBackground: PropTypes.bool
};

LogoImage.defaultProps = {
  darkBackground: false
};


// WEBPACK FOOTER //
// ./src/components/logo/index.js